import { Cloud$BusinessUnitConfig } from '../types/cloudApi';
import { Otovo$Locale } from '../types/otovoweb';

type Args = {
  locale: Otovo$Locale | undefined;
  buConfig: Cloud$BusinessUnitConfig;
};
export default function getSanityLocaleDocumentQuery({
  buConfig,
  locale,
}: Args) {
  if (!locale) {
    return '';
  }
  const shouldQueryForDocumentsWithLocale = buConfig.isMultiLocaleBu;
  // Don't care about the document's language for single-locale business units.
  if (!shouldQueryForDocumentsWithLocale) {
    return '';
  }
  const defaultLocale = buConfig.locale;
  if (locale === defaultLocale) {
    // The language property won't be set before the content editor sets the
    // language. Therefore, accept a blank language property for the default locale.
    // The latter `!defined` check handles cases where the language property is
    // missing in the document, for example if the language property is not part
    // of the document's schema.
    return `&& (language == "" || language == "${defaultLocale}" || !defined(language))`;
  }
  // We require the language property to be set on documents written in non-default
  // locales.
  return `&& language == "${locale}"`;
}
